import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '@app/services/auth/auth.service';
import { ConfirmationService, MessageService } from 'primeng/api';


@Component({
  selector: 'app-admin-lock-unlock-system',
  templateUrl: './admin-lock-unlock-system.component.html',
  styleUrls: ['./admin-lock-unlock-system.component.css']
})
export class AdminLockUnlockSystemComponent implements OnInit {
  form;
  
  ongoinglockout;
  lockouts;
  showMessage = false;
  edit = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService,
    private datePipe: DatePipe) { }

  ngOnInit() {
    this.form = this.fb.group({
      SystemLockOutId: [null, ''],
      LockedOutByMemberId: [null, ''],
      SystemLockOutMessage: ['Systemet nedstängt för underhåll. Beräknas åter vara igång ', ''],
      LockOutFrom: ['', Validators.required],
      LockOutUntil: ['', Validators.required]
    });
    this.authService.getSystemLockOuts().subscribe(lockouts => {
      if (lockouts) {
        this.lockouts = lockouts;
        if (this.lockouts?.length > 0) {
          this.ongoinglockout = this.lockouts[this.lockouts.length - 1];
          if (new Date(this.ongoinglockout.lockOutUntil) > new Date()) {
            this.ongoinglockout = this.lockouts[this.lockouts.length - 1];
            this.showMessage = true;
          } else {
            this.ongoinglockout = [];
            this.showMessage = false;
          }
        }
      }
    });
  }

  editLockedSystem() {
    this.edit = true;
    this.form.controls['SystemLockOutMessage'].setValue(this.ongoinglockout.systemLockOutMessage);
    this.form.patchValue({ 'LockOutFrom': this.datePipe.transform(this.ongoinglockout.lockOutFrom, 'yyyy-MM-dd HH:mm') });
    this.form.patchValue({ 'LockOutUntil': this.datePipe.transform(this.ongoinglockout.lockOutUntil, 'yyyy-MM-dd HH:mm') });
  }

  lockSystem() {
    const input = {
      SystemLockOutMessage: this.form.get('SystemLockOutMessage').value,
      LockOutFrom: this.form.get('LockOutFrom').value,
      LockOutUntil: this.form.get('LockOutUntil').value
    }
    this.authService.addLockout(input).subscribe(response => {
      this.edit = false;
      this.ngOnInit();
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Systemet har låsts.' });
    });
  }

  updateLockSystem() {
    const input = {
      SystemLockOutId: this.ongoinglockout.id,
      LockedOutByMemberId: this.ongoinglockout.lockedOutByMemberId,
      SystemLockOutMessage: this.form.get('SystemLockOutMessage').value,
      LockOutFrom: this.form.get('LockOutFrom').value,
      LockOutUntil: this.form.get('LockOutUntil').value,
    }

    this.authService.updateLockout(input).subscribe(response => {
      if (response) {
        this.edit = false;
        this.ngOnInit();
      }
    });
  }
  unlockSystem() {
    this.authService.deleteLockout(this.ongoinglockout.id).subscribe(response => {
      if (response) {
        this.showMessage = false;
        this.ongoinglockout = [];
        this.form.patchValue({ SystemLockOutMessage: 'Systemet nedstängt för underhåll. Beräknas åter vara igång ' });
        this.form.patchValue({ LockOutFrom: '' });
        this.form.patchValue({ LockOutUntil: '' });
        this.showInfoDialog();
      }
    });
  }

  setDateFormat() {
    this.form.patchValue({ 'LockOutFrom': this.datePipe.transform(this.form.get('LockOutFrom').value, 'yyyy-MM-dd HH:mm') });
    this.form.patchValue({ 'LockOutUntil': this.datePipe.transform(this.form.get('LockOutUntil').value, 'yyyy-MM-dd HH:mm') });
  }

  showInfoDialog(): void {
     this.confirmationService.confirm({
      header: 'Information',
      message: 'Systemet har låsts upp.',
      acceptLabel: 'Ok',
      rejectVisible: false,
      accept: () => {
      },
      reject: () => {
      }
    });
  }

  cancelEdit() {
    this.edit = false;
  }
}
